class GTCLinkedProducts extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.dom = {
          currentColorName: this.querySelector('.gtc\\:linked-products [current-color-name]')
      };

      this.Init();
  }

  disconnectedCallback() { }

  Init() {
      this.ChangeColorNameOnHover();
  }

  ChangeColorNameOnHover() {
      if (this.dom.currentColorName) {
          const currentColorNameText = this.dom.currentColorName.hasAttribute('current-color-name') ? this.dom.currentColorName.getAttribute('current-color-name') : ''

          const changeColorName = (text) => {
              this.dom.currentColorName.innerText = text
          }

          this.addEventListener('mouseover', (event) => {
              const colorNameElem = event.target.closest('[color-name]');
              changeColorName(colorNameElem ? colorNameElem.getAttribute('color-name') : currentColorNameText)
          });

          this.addEventListener('mouseout', () => {
              changeColorName(currentColorNameText)
          });
      }
  }
}
customElements.define('gtc-linked-products', GTCLinkedProducts)